<div class="flex align-items-center margin-bottom-small">
    <lib-svg-icon [iconName]="iconName()" [color]="iconColor()" class="margin-right-small" />
    <ng-content></ng-content>
</div>
